import type { Router } from 'vue-router'
const DefaultLayout = () => import('@/layouts/default-layout.vue')

const moduleRoute = {
  path: '/',
  component: DefaultLayout,
  children: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login-view.vue'),
    },
    {
      path: '/create-account',
      name: 'create-account',
      component: () => import('./views/create-account-view.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('./components/change-password.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./components/forgot-password.vue'),
    }
  ],
}

const routes = (router: Router) => {
  router.addRoute(moduleRoute)
}

export default {
  routes,
}
